// import React from "react";

// const InfoTextAdv = () => {
//   return <div>InfoTextAdv</div>;
// };

// export default InfoTextAdv;

import React from "react";

const sizeStyles = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const sizeValueStyles = {
  sm: "text-[14px]",
  md: "text-[16px]",
  lg: "text-[18px]",
  xl: "text-[20px]",
};

const iconSizeStyles = {
  sm: "text-[18px]",
  md: "text-[20px]",
  lg: "text-[24px]",
  xl: "text-[28px]",
};

const InfoTextAdv = ({
  title,
  titleProps,
  icon = "info",
  value, // its value or html element
  size = "md", //sm,md,lg,xl
  textWrap = false,
  oneLine = false,
  color = "black", // primary, warning, success, danger, info, black, white
}) => {
  const colorStyles = {
    primary: "text-primary",
    warning: "text-warning",
    success: "text-success",
    danger: "text-danger",
    info: "text-info",
    black: "text-black",
    white: "text-white",
  };

  // Handle size as either a string or an object
  const textSize = typeof size === "object" ? size.textSize || "md" : size;
  const valueSize = typeof size === "object" ? size.valueSize || "md" : size;
  const iconSize = typeof size === "object" ? size.iconSize || "md" : size;

  // Check if value is a React element
  const isReactComponent = React.isValidElement(value);

  //check titleProps has className separate  other are separate
  const { className: titlePropsClassName, ...titlePropsRest } =
    titleProps || {};

  return (
    <div
      className={`flex ${
        title ? "text-neutrals flex-col gap-2" : "flex-row items-center gap-2"
      } ${oneLine && "!flex-row items-center"} `}
      {...titlePropsRest}
    >
      {title ? (
        <div
          className={`leading-none text-nowrap ${titlePropsClassName} ${sizeStyles[textSize]}`}
        >
          {title}
        </div>
      ) : (
        <span
          className={`material-symbols-rounded font-extralight ${iconSizeStyles[iconSize]}`}
        >
          {icon}
        </span>
      )}
      <div>
        {isReactComponent ? (
          value
        ) : (
          <div
            className={` ${colorStyles[color]}   ${
              !textWrap ? "text-nowrap leading-none" : "leading-tight"
            }  ${sizeValueStyles[valueSize]}`}
          >
            {value === undefined || value === null || value === ""
              ? "n/a"
              : value}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoTextAdv;
